import axios from 'axios'
import strings from './strings/english'
import keycloak from './keycloack'
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_KEYCLOAK_URL,
  timeout: 500000
})
axiosInstance.interceptors.request.use(
  async (config) => {
    if (keycloak.authenticated === false) {
      throw new Error(strings.session_expired)
    }
    if (keycloak.isTokenExpired(120)) {
      console.log('refresing token')
      await keycloak.updateToken(120)
    }
    config.headers.Authorization = `Bearer ${keycloak.token}`
    return config
  },
  (error) => {
    console.log('axios.interceptors error')
    return error
  }
)

export const addWalletToKeyCloakApi = async (
  walletAddress: string,
  stakeAddress: string,
  walletSignature: string,
  walletMessage: string,
  walletBlockchain: string,
  walletType: string,
  isPrimary: boolean,
  walletSignatureKey: string
): Promise<any | null> => {
  try {
    const respoinceADDWallet = await axiosInstance.post<any, any>(
      `/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/userWalletAdministration/linkWalletToUser`,
      {
        walletAddress,
        stakeAddress,
        walletSignature,
        walletMessage,
        walletBlockchain,
        walletType,
        isPrimary
      }
    )
    if (respoinceADDWallet.data !== null) {
      return respoinceADDWallet.data?.data
    }
  } catch (error: any) {
    if (keycloak.authenticated === false) {
      throw new Error(strings.session_expired)
    } else {
      throw new Error(error?.response?.data?.message?.toString() ?? strings.try_again_later)
    }
  }
  return null
}

export const getWalletsKeyCloakApi = async (): Promise<any | null> => {
  try {
    const responce = await axiosInstance.get<any, any>(
      `/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/userWalletAdministration/wallets`
    )
    if (responce.data !== null) {
      return { success: true, data: responce.data?.data }
    }
  } catch (error) {
    if (keycloak.authenticated === false) {
      return { success: false, message: strings.session_expired }
    }
    return { success: false, message: strings.try_again_later }
  }
  return null
}

export const deleteKeyCloakWallet = async (
  walletAddress: string
): Promise<any | null> => {
  try {
    const responce = await axiosInstance.delete<any, any>(
      `/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/userWalletAdministration/disconnectWallet`,
      {
        data: {
          walletAddress
        }
      }
    )
    if (responce.data !== null) {
      return responce.data?.data
    }
  } catch (error) {
    return null
  }
  return null
}

export const getFirestoreCustomToken = async (
  token: string
): Promise<any | null> => {
  try {
    const responce = await axiosInstance.get<any, any>(
      `/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/userWalletAdministration/firebase-token`,
      {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`
        }
      }
    )
    if (responce.data !== null) {
      return responce.data?.data
    }
  } catch (error) {
    return null
  }
  return null
}
export const updatePasscodeAPI = async (passcode: string): Promise<any | null> => {
  try {
    const responce = await axiosInstance.post<any, any>(
      `/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/userWalletAdministration/updatePasscode`,
      {
        passcode
      }
    )
    if (responce.data !== null) {
      return { success: true, message: responce.data?.message }
    }
  } catch (error) {
    if (keycloak.authenticated === false) {
      return { success: false, message: strings.session_expired }
    }
  }
  return { success: false, message: 'Update Passcode request failed. Please try again' }
}
